// extracted by mini-css-extract-plugin
module.exports = {"gridcontainer":"Home_gridcontainer__m4__N","title":"Home_title__3h164","swipeLeft":"Home_swipeLeft__3bEwC","cover":"Home_cover__3-oWl","mia":"Home_mia__1rD2H"};